import { Timestamp } from 'firebase/firestore';
import PropTypes from 'prop-types';

const auditPropTypes = {
  createdAt: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.instanceOf(Timestamp),
  ]).isRequired,
  updatedAt: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.instanceOf(Timestamp),
  ]),
};

export default auditPropTypes;
